import React from "react";
import { Alert, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useIntercom } from "react-use-intercom";
import { LoanApi, LoanPreviewMode } from "../../../../../services/Api/types";

interface Props {
	mode?: LoanPreviewMode;
	loan: LoanApi;
}

const LoanPreviewAlerts = ({ mode, loan }: Props) => {
	const { t } = useTranslation("admin");
	const { show } = useIntercom();

	if (mode === LoanPreviewMode.CLIENT) return <></>;

	const getAlertTextForConfirmedLoan = () => {
		if (loan.type === "GOPOS") return t("modules.loan.field.gopos_loan_warning.title");
		if (loan.type === "POSNET")
			return (
				<>
					{t("modules.loan.field.vero_loan_warning_0.title")}
					<strong>"{t("modules.loan.field.accepted.title")}"</strong>
					{t("modules.loan.field.vero_loan_warning_1.title")}{" "}
					{t("modules.loan.field.vero_loan_warning_2.title")}
					<strong>{t("modules.loan.field.vero_loan_warning_3.title")}</strong>{" "}
					{t("modules.loan.field.vero_loan_warning_4.title")}
					<strong>"{t("modules.loan.field.accepted.title")}"</strong> {t("common.word.to", { ns: "lib" })}
					<strong>"{t("modules.loan.field.closed.title")}"</strong>
					{t("modules.loan.field.vero_loan_warning_6.title")}
				</>
			);
		return "";
	};

	const openChat = () => {
		show();
	};

	return (
		<>
			{loan.status === "ACCEPTED" && (
				<>
					<Alert variant="warning" className="mb-3">
						{getAlertTextForConfirmedLoan()}
					</Alert>
					{loan.type === "GOPOS" && (
						<Button onClick={openChat} className="mb-3">
							{t("modules.loan.action.start_chat_conversation.title")}
						</Button>
					)}
				</>
			)}
			{loan.status === "OPEN" && loan.acceptation_status === "OPEN" && (
				<>
					<Alert variant="warning" className="mb-3">
						{t("modules.loan.field.loan_waiting_for_client_acceptation.title")}
					</Alert>
				</>
			)}
			{loan.status === "OPEN" && loan.signing_status === "OPEN" && (
				<>
					<Alert variant="warning" className="mb-3">
						{loan.attachments.length <= 0 ? (
							<>{t("modules.loan.field.no_attachments.title")}</>
						) : (
							<>{t("modules.loan.field.loan_accepted.title")}</>
						)}
					</Alert>
				</>
			)}
		</>
	);
};

export default LoanPreviewAlerts;
